import { type OpenApiSchemaPromocodeGroup } from '#shared/api/schema';
import { type PromoactionModel } from '../types';

export const mapPromocodeGroupToPromoaction = (promocodeGroup: OpenApiSchemaPromocodeGroup): PromoactionModel => {
    const isPercent = promocodeGroup.discount_type === 'percent';

    let value_percent = '';
    let value_fixed = '';

    if (isPercent) {
        value_percent = promocodeGroup.discount_value;
    } else {
        value_fixed = promocodeGroup.discount_value;
    }

    return {
        id: promocodeGroup.id,
        title: promocodeGroup.title,
        kind: 'REGULAR',
        mode: {
            mode: 'promocode',
            promocodeGroupType: promocodeGroup.group_type,
            promocodeGroupId: promocodeGroup.id,
            codeCount: promocodeGroup.code_count,
        },
        discount: {
            type: promocodeGroup.discount_type,
            value_percent,
            value_fixed,
            minimum_order_amount: promocodeGroup.minimum_order_amount ?? '',
            max_discount_amount: promocodeGroup.max_discount_amount ? String(promocodeGroup.max_discount_amount) : '',
        },
        validity: {
            isOneTimeUse: promocodeGroup.one_time_use ? 'true' : 'false',
            isFirstOrderOnly: promocodeGroup.first_order_only ? 'true' : 'false',
            maxUsageLimit: promocodeGroup.max_usage ? 'true' : 'false',
            isPermanent: !promocodeGroup.valid_until,
            validFrom: promocodeGroup.valid_from,
            validUntil: promocodeGroup.valid_until || '',
        },
        applicability: {
            type: promocodeGroup.applicability_type,
            appliedCategoryIds: promocodeGroup.applied_category_ids ?? [],
            appliedCollectionIds: promocodeGroup.applied_collection_ids ?? [],
            appliedProductListId: promocodeGroup.applied_product_list_id ?? '',
        },
        badge: null,
        autoCollectionId: '',
        autoCollectionTitle: '',
        autoCollectionDescription: '',
        showAutoCollectionInFeed: false,
        showInPdp: promocodeGroup.show_in_pdp ? 'true' : 'false',
        meta: {
            type: promocodeGroup.type === 'ORDER' ? 'on_orders' : 'on_products',
            usageCount: promocodeGroup.usage_count,
            deactivated: promocodeGroup.deactivated,
            status: promocodeGroup.status,
            createdAt: promocodeGroup.created_at,
            updatedAt: promocodeGroup.updated_at,
        },
    };
};
